import apiClient from './api';

const amenitiesService = {
    // Önbellek için değişken
    _cache: null,
    _cacheTimestamp: null,
    _cacheDuration: 24 * 60 * 60 * 1000, // 24 saat

    // Önbelleği temizle
    clearCache: () => {
        amenitiesService._cache = null;
        amenitiesService._cacheTimestamp = null;
    },

    // Önbelleği kontrol et
    _isCacheValid: () => {
        if (!amenitiesService._cache || !amenitiesService._cacheTimestamp) {
            return false;
        }
        const now = new Date().getTime();
        return (now - amenitiesService._cacheTimestamp) < amenitiesService._cacheDuration;
    },

    // Tüm olanakları getir
    getAmenities: async () => {
        try {
            // Önbellek kontrolü
            if (amenitiesService._isCacheValid()) {
                return amenitiesService._cache;
            }

            // API'den veri çek
            const response = await apiClient.get('facilities');
            
            // Veriyi önbelleğe al
            amenitiesService._cache = response.data.data;
            amenitiesService._cacheTimestamp = new Date().getTime();
            
            return amenitiesService._cache;
        } catch (error) {
            console.error('Error fetching amenities:', error);
            return [];
        }
    },

    // Belirli bir olanağı ID'ye göre getir
    getAmenityById: async (id) => {
        try {
            const amenities = await amenitiesService.getAmenities();
            return amenities.find(amenity => amenity.id === id);
        } catch (error) {
            console.error('Error fetching amenity by id:', error);
            return null;
        }
    },

    // Olanakları koda göre filtrele
    getAmenitiesByCode: async (code) => {
        try {
            const amenities = await amenitiesService.getAmenities();
            return amenities.filter(amenity => amenity.code === code);
        } catch (error) {
            console.error('Error fetching amenities by code:', error);
            return [];
        }
    },

    // Olanakları gruba göre filtrele
    getAmenitiesByGroup: async (group) => {
        try {
            const amenities = await amenitiesService.getAmenities();
            return amenities.filter(amenity => amenity.group === group);
        } catch (error) {
            console.error('Error fetching amenities by group:', error);
            return [];
        }
    }
};

export default amenitiesService; 